import {IHttpResponse, IPromise} from "angular";
import {Page, Pageable} from "../../utils/models/Page";
import './CustomerProfile.scss';
import {ArchivedLoanLog} from "../../loan_archive/model/ArchivedLoanLog";
import {CustomerInfoOptions} from "../model/CustomerInfoOptions";
import {Customer} from "../../customers/model/Customer";
import {CustomerDetailsService} from "../../customer_service/service/CustomerDetailService";
import {CampaignActionLogService} from "../../campaigns_service/service/CampaignActionLogService";
import {Calculator} from "../../calculations/model/Calculator";
import {ContactProfileTab} from "../../contact/model/ContactProfileTab";
import {CampaignActionLogServiceName, CUSTOMER_DETAILS_SERVICE_NAME} from "../../utils/names/serviceNames";
import {
    ConversionLogAwareContactProfileController,
    ConversionLogAwareContactProfileScope
} from "../../contact/controller/contact_profile/impl/ConversionLogAwareContactProfileController";
import {ContactType} from "../../contact/model/Contact";

export interface CustomerProfileControllerScope extends ConversionLogAwareContactProfileScope<Customer> {
    logs?: any[];
    archivedLoans?: Page<ArchivedLoanLog>;
    selectedId: number;
    fetchCustomerLogs: () => IPromise<void>;
    pagingConfig: Pageable;

    selectedContact: Customer;
    selectedTabIndex: number;
    customerInfoOptions: CustomerInfoOptions;

}

export class CustomerProfileController extends ConversionLogAwareContactProfileController<Customer, CustomerProfileControllerScope> {

    static instanceConstructor = [
        '$scope',
        '$routeParams',
        'selectedCustomer',
        CampaignActionLogServiceName,
        CUSTOMER_DETAILS_SERVICE_NAME,
        CustomerProfileController
    ];


    constructor($scope: CustomerProfileControllerScope,
                $routeParams: ng.route.IRouteParamsService,
                selectedCustomer: Customer,
                campaignActionLogService: CampaignActionLogService,
                private customerDetailService: CustomerDetailsService) {
        super($scope, $routeParams, selectedCustomer, campaignActionLogService);
        $scope.fetchCustomerLogs = () => {
            let pageConfig = this.$scope.pagingConfig;
            return this.customerDetailService.getCustomerCalculationLog(
                $scope.selectedContact.id,
                pageConfig.page - 1,
                pageConfig.pageSize)
                .then((resp: IHttpResponse<Page<any>>) => {
                    if (resp.status === 200) {
                        let customerLogsPage = resp.data;
                        customerLogsPage.content.forEach(log => {
                            log.imageUrl = Calculator.getImageUrl(log.calculatorName);
                        });
                        $scope.logs = customerLogsPage.content;
                        this.updatePagingConfig(customerLogsPage, pageConfig);
                    }
                });
        };

        $scope.pagingConfig = this.initPagingConfig($scope.fetchCustomerLogs);
        $scope.fetchCustomerLogs();
        $scope.customerInfoOptions = this.initCustomerInfoOptions();
    }

    private initCustomerInfoOptions(): CustomerInfoOptions {
        return {
            readonly: false
        }
    }

    protected tabs(): ContactProfileTab[] {
        return [
            ContactProfileTab.BASIC,
            ContactProfileTab.MAILING_ADDRESS,
            ContactProfileTab.OPPORTUNITIES,
            ContactProfileTab.DATE_FIELDS,
            ContactProfileTab.LOAN,
            ContactProfileTab.PROPERTY,
            ContactProfileTab.MARKETING,
            ContactProfileTab.FINANCIALS,
            ContactProfileTab.CO_BORROWERS,
            ContactProfileTab.APPLICATION,
            ContactProfileTab.OPPORTUNITY_LOG,
            ContactProfileTab.CAMPAIGN_LOG
        ]
    }


    protected contactType(): ContactType {
        return ContactType.CUSTOMER;
    }
}